/**
 * @generated SignedSource<<98c2cd4a8ad959268b333d51fbbe9d75>>
 * @relayHash 13588cd8240171a496a5fe60c65cb262
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0fcf03d0cb9904b89bdf05664b1123004945846c5af8b2ea4b1f311b292386d0

import type { ConcreteRequest } from 'relay-runtime';
export type AVPDataFetchStrategy = "DYNAMIC" | "STATIC" | "%future added value";
export type AVPIntegrationId = "ASSETS_VERTICAL" | "ATLASSIAN_ANALYTICS" | "JIRA_SPACE_DASHBOARDS_KANBAN" | "JIRA_SPACE_DASHBOARDS_SCRUM" | "JIRA_SUMMARY_PAGE" | "JSM_ASSETS" | "JSM_OPERATIONS_GLOBAL" | "JSM_OPERATIONS_TEAM" | "JSM_SUMMARY_PAGE" | "TOWNSQUARE" | "%future added value";
export type AVPJqlSourceType = "FILTER_ID" | "%future added value";
export type AVPChartInput = {
  chartConfig?: AVPChartConfigInput | null;
  chartType?: string | null;
  envVarId?: string | null;
  id?: string | null;
  pipeline?: AVPChartPipelineInput | null;
  templateChartId?: string | null;
};
export type AVPChartConfigInput = {
  clientSettings?: AVPChartClientSettingsInput | null;
  dataFetchStrategy?: AVPDataFetchStrategy | null;
  settings?: ReadonlyArray<AVPChartSettingInput> | null;
  vizConfig?: AVPVizConfigInput | null;
};
export type AVPChartClientSettingsInput = {
  options?: ReadonlyArray<AVPChartSettingInput> | null;
  type?: string | null;
};
export type AVPChartSettingInput = {
  jsonValue?: string | null;
  name: string;
};
export type AVPVizConfigInput = {
  accessors?: AGG$JSON | null;
  data: ReadonlyArray<ReadonlyArray<AGG$JSON | null>>;
};
export type AVPChartPipelineInput = {
  id?: string | null;
  nodes?: ReadonlyArray<string | null> | null;
  queries?: ReadonlyArray<AVPChartPipelineQueryInput> | null;
};
export type AVPChartPipelineQueryInput = {
  datasourceId?: string | null;
  datasourceLocator: AVPDatasourceLocatorInput;
  dimensions?: ReadonlyArray<AVPChartPipelineQueryDimensionInput> | null;
  filterLogic?: string | null;
  filters?: ReadonlyArray<AVPChartPipelineQueryFilterInput> | null;
  id?: string | null;
  isManual?: boolean | null;
  joins?: ReadonlyArray<string | null> | null;
  limit?: number | null;
  measures?: ReadonlyArray<AVPChartPipelineQueryMeasureInput> | null;
  metricsConfiguration?: AVPMetricsConfigurationInput | null;
  name?: string | null;
  sql?: string | null;
};
export type AVPDatasourceLocatorInput = {
  datasourceId?: string | null;
  dstype: string;
  workspaceId: string;
};
export type AVPChartPipelineQueryDimensionInput = {
  bucketFunction?: string | null;
  columnName?: string | null;
  label: string;
  operands: ReadonlyArray<string>;
  pivotColumnFieldType?: string | null;
  pivotColumnName?: string | null;
  schemaName?: string | null;
  sortDir?: number | null;
  tableName?: string | null;
};
export type AVPChartPipelineQueryFilterInput = {
  autoEnvVarId?: string | null;
  autoEnvVarRemoved?: boolean | null;
  columnName?: string | null;
  comparison: string;
  group?: number | null;
  isAuto?: boolean | null;
  label: string;
  operands: ReadonlyArray<string>;
  pivotColumnFieldType?: string | null;
  pivotColumnName?: string | null;
  schemaName?: string | null;
  tableName?: string | null;
};
export type AVPChartPipelineQueryMeasureInput = {
  aggregationFunction?: string | null;
  columnName?: string | null;
  label: string;
  pivotColumnFieldType?: string | null;
  pivotColumnName?: string | null;
  schemaName?: string | null;
  sortDir?: number | null;
  tableName?: string | null;
};
export type AVPMetricsConfigurationInput = {
  dimensions?: ReadonlyArray<AVPMetricsConfigurationDimensionInput> | null;
  filters?: ReadonlyArray<AVPMetricsConfigurationFilterInput> | null;
  granularity?: string | null;
  jqlSource?: AVPJqlSourceInput | null;
  metrics?: ReadonlyArray<string> | null;
  searchCondition?: string | null;
  workspaceId?: string | null;
};
export type AVPMetricsConfigurationDimensionInput = {
  name: string;
  type: string;
};
export type AVPMetricsConfigurationFilterInput = {
  comparison: string;
  dimension: string;
  operands: ReadonlyArray<string>;
  product: string;
  withNullValue?: boolean | null;
};
export type AVPJqlSourceInput = {
  filterId?: string | null;
  type: AVPJqlSourceType;
};
export type standaloneChartsVizCreateMutation$variables = {
  chart: AVPChartInput;
  cloudId: string;
  containerAri?: string | null;
  integrationId?: AVPIntegrationId | null;
  workspaceAri?: string | null;
};
export type standaloneChartsVizCreateMutation$data = {
  readonly avp_createStandaloneChart: {
    readonly avpVizUrl: string | null;
    readonly chart: {
      readonly chartType: string | null;
      readonly id: string | null;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly extensions: {
        readonly statusCode: number | null;
      } | null;
      readonly message: string | null;
    }> | null;
    readonly success: boolean;
  } | null;
};
export type standaloneChartsVizCreateMutation = {
  response: standaloneChartsVizCreateMutation$data;
  variables: standaloneChartsVizCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chart"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerAri"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "integrationId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceAri"
},
v5 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "chart",
        "variableName": "chart"
      },
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "containerAri",
        "variableName": "containerAri"
      },
      {
        "kind": "Variable",
        "name": "integrationId",
        "variableName": "integrationId"
      },
      {
        "kind": "Variable",
        "name": "workspaceAri",
        "variableName": "workspaceAri"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "success"
},
v7 = {
  "kind": "ScalarField",
  "name": "avpVizUrl"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
},
v9 = {
  "concreteType": "AVPChart",
  "kind": "LinkedField",
  "name": "chart",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "ScalarField",
      "name": "chartType"
    }
  ]
},
v10 = {
  "kind": "ScalarField",
  "name": "message"
},
v11 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "standaloneChartsVizCreateMutation",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "AVPCreateStandaloneChartPayload",
        "kind": "LinkedField",
        "name": "avp_createStandaloneChart",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v9/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  (v11/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "standaloneChartsVizCreateMutation",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "AVPCreateStandaloneChartPayload",
        "kind": "LinkedField",
        "name": "avp_createStandaloneChart",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v9/*: any*/),
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v10/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v11/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/)
                    ],
                    "type": "BulkMutationErrorExtension"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "0fcf03d0cb9904b89bdf05664b1123004945846c5af8b2ea4b1f311b292386d0",
    "metadata": {},
    "name": "standaloneChartsVizCreateMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "b7c2b5e8fc7437b3c032514653d596e5";

export default node;
